import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DoctorAppointment, EAppointmentState } from 'src/app/entities/appointment.entity';
import { ConsultationMotif } from 'src/app/entities/consultation.entity/consultation-motif.entity/consultation-motif';
import { EDalyTimeSlotLocation } from 'src/app/entities/daly-time-slot.entity/daly-time-slot';
import { DoctorAvailability } from 'src/app/entities/doctor-disponiblity.entity/doctor-availability';
import { DoctorPatient } from 'src/app/entities/doctor-patient.entity/doctor-patient';
import { Doctor } from 'src/app/entities/user.entity/doctor.entity';
import { DoctorSecretary } from 'src/app/entities/user.entity/doctor.entity/secretary.entity';
import { AuthService } from 'src/app/services/auth.service/auth.service';
import { DoctorSecretariesService } from 'src/app/services/doctor-secretaries.service/doctor-secretaries.service';
import { DoctorSecretaryAppointmentsService } from 'src/app/services/doctor-secretary-appointments.service/doctor-secretary-appointments.service';

@Component({
  selector: 'app-create-rendez-vous-secretary',
  templateUrl: './create-rendez-vous-secretary.component.html',
  styleUrls: ['./create-rendez-vous-secretary.component.css']
})
export class CreateRendezVousSecretaryComponent implements OnInit, OnChanges {

  @Input() doctorPatients: Array<DoctorPatient> = new Array();
  @Input() userTarget!: DoctorPatient;
  submited: boolean = false;
  @Input() location: EDalyTimeSlotLocation = EDalyTimeSlotLocation.ATSITE;
  @Input() disponibilites: Array<DoctorAvailability> = new Array();
  @Input() disponibiliteDefalut: number = 0;
  disponibilite: DoctorAvailability | any = new DoctorAvailability({});
  doctorAppointment: DoctorAppointment = new DoctorAppointment({
    status: EAppointmentState.PENDING,
    motif: "Consultation Régulière",
  });
  @Input() consultationMotifs: Array<ConsultationMotif> = [];
  @Input() date: string = "";
  @Input() dateDisponibilte!: Date;

  constructor(
    private doctorSecretaryAppointmentsService: DoctorSecretaryAppointmentsService,
    private authservice: AuthService,
    private toastrService: ToastrService,
    private doctorSecretariesService: DoctorSecretariesService
  ) {}

  heureInput: string = "";

  @Input() creationPatient: boolean = false;
  @Output() creationPatientChange: EventEmitter<boolean> = new EventEmitter();
  @Output() close: EventEmitter<void> = new EventEmitter();
  @Input() filter:boolean=false;
  @Output() refreshData:EventEmitter<void> =new EventEmitter()

  listesAssistants:Array<any> = new Array();
  selectedAssistant: any;
  selectedColor: string = '';

  changeValueDisponibilte: boolean = false;

  get secrectary (): DoctorSecretary {
    return this.authservice.getCurrentUser() as DoctorSecretary;
  }
  // ✅ COLORS
  colors = [
    { value: "#FADADD", color: "rose clair" },
    { value: "#B8E994", color: "vert pastel" },
    { value: "#FFF9B0", color: "jaune clair" },
    { value: "#A8D8EA", color: "bleu ciel doux" },
    { value: "#FFDAB9", color: "pêche" },
    { value: "#E6E6FA", color: "lavande" },
    { value: "#DFFFBF", color: "vert pomme clair"},
    { value: "#F5F5DC", color: "beige doux" },
    { value: "#BFD7ED", color: "bleu pastel" },
    { value: "#FFB6B9", color: "corail clair" }
  ];

  getRandomColor() {
    return this.colors[Math.floor(Math.random() * this.colors.length)];
  }

  // ✅ NEW → appliquer couleur selon user
  applyUserColor(user: any) {
    if (!user) return;
    this.doctorAppointment.colorCode =
      user?.colorCodeAct || this.getRandomColor().value;
  }

  isOpen = false;

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  // ✅ MODIFIÉ → sélection manuelle garde priorité
  selectColor(color: string) {
    this.doctorAppointment.colorCode = color;
    this.isOpen = false;
  }

  onTimeChange(event: any) {
    const value = event.target.value;

    if (!value) {
      this.disponibilite.startTime = 0;
      return;
    }

    const [hours, minutes] = value.split(":").map(Number);

    const milliseconds =
      (hours * 60 * 60 * 1000) +
      (minutes * 60 * 1000);

    this.disponibilite.startTime = milliseconds;
    this.disponibiliteDefalut =milliseconds
  }

  usersList: any[] = [];
  selectedUser: any;

  getAssistants() {
    this.doctorSecretariesService.getAssistantList().subscribe({
      next: (res: any) => {

        const medecin = {
          ...res.medecin,
          type: 'DOCTOR'
        };

        // ✅ DEFAULT = médecin
        this.selectedUser = medecin;
        this.applyUserColor(medecin);

        const assistants = res.assistants.map((a: any) => ({
          ...a,
          type: 'ASSISTANT'
        }));

        this.usersList = [medecin, ...assistants];
      }
    });
  }

  // ✅ NEW → utiliser cette méthode dans ton HTML
  setSelectedUser(user: any) {
    this.selectedUser = user;
    this.applyUserColor(user);
  }
  onUserChange() {
    if (this.selectedUser) {
      this.selectedColor = this.selectedUser.colorCodeAct || '#FADADD';
      this.doctorAppointment.colorCode = this.selectedColor;
      
    }
  }

  ngOnInit(): void {
    this.getAssistants();

this.location=this.secrectary.doctor.timeSlotLocalSetting  == 0  ? 0: this.secrectary.doctor.timeSlotLocalSetting == 2? 0 : 1;

    this.filter==false?this.changeValueDisponibilte=false:this.changeValueDisponibilte=true

    if (this.disponibiliteDefalut !== 0) {
      this.heureInput = this.msToTime(this.disponibiliteDefalut);
      this.disponibilite.startTime = this.disponibiliteDefalut;
    }
  }


   ngOnChanges() {
       if (this.disponibiliteDefalut !== 0) {
      this.heureInput = this.msToTime(this.disponibiliteDefalut);
    }

    if (this.usersList.length && this.doctorAppointment?.assistantId) {
      this.selectedUser = this.usersList.find(
        u => u.id === this.doctorAppointment.assistantId
      );

      // ✅ init couleur depuis backend
      this.selectedColor = this.doctorAppointment.assistanceColorCode || this.doctorAppointment.colorCode;
    }
  }

  msToTime(ms: number): string {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  refresh(event: DoctorPatient) {
    this.userTarget = event;
    this.refreshData.emit()
  }

  change(event: any) {
    this.changeValueDisponibilte = event.isTrusted;
  }

  sumbit() {
this.submited=true;
    if (this.changeValueDisponibilte == false && this.disponibiliteDefalut != 0) {

      this.disponibilite.startTime = this.disponibiliteDefalut

      let disponibiliteExits = this.disponibilites.filter(elm => elm.startTime == this.disponibiliteDefalut);

      if (disponibiliteExits.length > 0)
        this.disponibilite.duration = disponibiliteExits[0].duration;
      else
        this.disponibilite.duration = 30;
    };

    this.doctorAppointment.date = new Date(
      this.dateDisponibilte.getFullYear(),
      this.dateDisponibilte.getMonth(),
      this.dateDisponibilte.getDate()
    );
this.doctorAppointment.location=this.location;   
 this.doctorAppointment.startTime =
      this.disponibilite.startTime != 0
        ? this.disponibilite.startTime
        : this.disponibilites[0].startTime;

    this.doctorAppointment.duration = this.disponibilite.duration;

    this.doctorAppointment.assistantId = this.selectedUser?.id || null;

    if (this.userTarget !== undefined) {

      this.doctorSecretaryAppointmentsService
        .add(this.userTarget.id, this.doctorAppointment)
        .subscribe({
          next: (res: any) => {
            this.toastrService.success("Rdv créé avec succès");

            this.doctorAppointment = new DoctorAppointment({});
            this.changeValueDisponibilte = false;
            this.userTarget = new DoctorPatient();

            this.refreshData.emit();
            this.close.emit();
          },

          error: (err) => {
            const msg = err?.error?.message || "Erreur lors de la création du rendez-vous";
            this.toastrService.error(msg);
            this.close.emit();
          }
        });

    } else {
      this.toastrService.warning("Veuillez sélectionner un patient");
      this.close.emit();
    }
  }
}